import { render, staticRenderFns } from "./restore-change-password.vue?vue&type=template&id=c8487206&scoped=true&"
import script from "./restore-change-password.vue?vue&type=script&lang=js&"
export * from "./restore-change-password.vue?vue&type=script&lang=js&"
import style0 from "./restore-change-password.vue?vue&type=style&index=0&id=c8487206&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8487206",
  null
  
)

export default component.exports